<template>
    <GuideModal>
        <div class="disclosure-popup">
            <div class="disclosure-popup-title">
                <div class="label">{{ disclosureText }}</div>
                <a class="icon" @click="closeDisclosurePopup"></a>
            </div>
            <div class="disclosure-popup-content" v-html="props.disclosurePopup"></div>
        </div>
    </GuideModal>
</template>
<script >
import GuideModal from './guide-modal.vue';
import { _lang } from '../common/lang';
import { computed } from 'vue-demi';
const __sfc_main = {};
__sfc_main.props = {
  disclosurePopup: {
    type: String,
    default: ''
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const disclosureText = computed(() => {
    return _lang(`disclosure`);
  });
  /**
   * 关闭披露弹窗
   */
  function closeDisclosurePopup() {
    emit('close');
  }
  return {
    props,
    disclosureText,
    closeDisclosurePopup
  };
};
__sfc_main.components = Object.assign({
  GuideModal
}, __sfc_main.components);
export default __sfc_main;
</script>
<style lang="less" scoped>
.disclosure-popup {
    width: 6rem;
    padding: 0.48rem;
    border-radius: 0.12rem;
    background-color: #e4e4e4;
    max-height: 80vh;
    overflow: auto;
    .disclosure-popup-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .label {
            line-height: 0.5rem;
            font-size: 0.36rem;
            color: #333;
        }
        .icon {
            display: inline-block;
            width: 0.32rem;
            height: 0.32rem;
            background: url('../images/close-pure.svg') no-repeat center;
            background-size: 0.32rem 0.32rem;
        }
    }
    .disclosure-popup-content {
        padding: 0.2rem 0;
        line-height: 0.4rem;
        font-size: 0.28rem;
        color: #333;
    }
}
</style>
